import { BoltUserCommentExpressionSchema } from "../../../types/BoltUserCommentExpressionSchema";
import {
  FieldSchemaFormBuilderV2,
  RichTextEditorFieldProps,
  RichTextEditorValueType,
  SchemaFactoryV2,
  TextAreaFieldProps,
  SwitchFieldProps,
} from "@ucl/library";
import { ContentMode } from "../InlineCommentEditor";

export const createBoltCommentFormBuilder: (
  factory: SchemaFactoryV2,
  contentMode: ContentMode
) => FieldSchemaFormBuilderV2<BoltUserCommentExpressionSchema> =
  (factory, contentMode) => (onValueChange, form, errors) => {
    const formFields = [
      ...factory.buildFieldSchemas<BoltUserCommentExpressionSchema>(
        "BoltUserCommentExpressionSchema",
        [
          {
            fieldKey: "BoltUserCommentExpressionSchema__IsHtml",
            value: form.isHtml,
            onSubmit: function (value) {
              onValueChange({ ...form, isHtml: value as boolean }, value, this);
            },
            hidden: contentMode !== "textOrHtml",
          } as SwitchFieldProps,
          {
            fieldKey: "BoltUserCommentExpressionSchema__MessageText",
            label: "",
            value: form.messageText || "",
            isRequired: false,
            errors: errors,
            placeholder: "Write Comment...",
            rows: 4,
            maxLength: 1000,
            onSubmit: function (value) {
              onValueChange(
                {
                  ...form,
                  messageText: value || "",
                },
                value,
                this
              );
            },
            hidden: !!form.isHtml,
          } as TextAreaFieldProps,
          {
            fieldKey: "BoltUserCommentExpressionSchema__MessageHtml",
            label: "",
            value: form.messageHtml,
            valueType: RichTextEditorValueType.html,
            isRequired: false,
            errors: errors,
            richTextEditorSettings: {
              toolbarSettings: {
                enable: true,
              },
              height: 240,
              placeholder: "Write Comment...",
            },
            getPlainTextOnSubmit: function (messageText) {
              onValueChange(
                {
                  ...form,
                  messageText: messageText || "",
                },
                messageText,
                this
              );
            },
            onSubmit: function (messageHtml) {
              onValueChange(
                {
                  ...form,
                  messageHtml: messageHtml || "",
                },
                messageHtml,
                this
              );
            },
            hidden: !form.isHtml,
          } as RichTextEditorFieldProps,
          // {
          //   fieldKey: "BoltUserCommentExpressionSchema__IsPinned",
          //   value: form.isPinned || false,
          //   onSubmit: function (value) {
          //     onValueChange(
          //       { ...form, isPinned: value as boolean },
          //       value,
          //       this
          //     );
          //   },
          // } as SingleCheckboxFieldProps,
        ],
        onValueChange,
        form,
        errors
      ),
    ];

    return formFields;
  };
